export default __webpack_public_path__ + "static/media/ToyotaSPM2.ab429dfa.png";